<form
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  class="simah-container rounded-lg shadow-md bg-white"
>
  <!-- Simah Logo -->
  <div class="text-center mb-4 d-flex flex-col items-center gap-4">
    <img
     src="assets/images/Logos/Simah_logo.png"
     alt="Simah"
     class="h-16 mx-auto simah-img"
   />
    <img
      src="assets/images/Logos/Bayan_logo.png"
      alt="Simah"
      class="h-16 mx-auto simah-img"
    />
  </div>

  <!-- Translatable Text -->
  <div [ngClass]="isArabic ? 'text-right' : 'text-left'" class="simah-text">
    <p class="text-lg">
      {{ "Simah.SIMAH_TEXT" | translate }}
    </p>
  </div>

  <!-- Checkbox -->
  <div class="mt-6 gap-2 flex items-center">
    <input
      type="checkbox"
      id="consent"
      formControlName="approve"
      class="h-5 cursor-pointer accent-blue-600"
    />
    <label for="consent" class="text-gray-800 font-semibold">
      {{ "Simah.CONSENT_LABEL" | translate }}
    </label>
  </div>

  <!-- Validation Message -->
  <div class="consent-required text-sm mt-2">
    <p class="text-danger" *ngIf="form.get('approve')?.invalid">
      {{ "Simah.CONSENT_REQUIRED" | translate }}
    </p>
  </div>
</form>
